<template>
  <div class="bg-gradient-greenblue d-flex align-center justify-center">
  <!-- <Boxlogin/> -->
  <div class="box-technology-login slide-in-bottom pa-6">
    <v-row :style="`${['lg', 'xl'].includes($vuetify.breakpoint.name)? 'width: 70%; margin-left: 20%;':'width 100%;'}`">
      <v-spacer />
      <v-col cols="12" sm="12" md="12" lg="6" class="d-flex flex-column align-center justify-center">
        <div class="elevation-2" :class="loading ? 'content-technology-logingin':'content-technology-login'" style="height: 70%; min-height: 500px;">
          <v-row class="d-flex align-center justify-center">
            <v-col cols="12" sm="12" md="12" lg="12" class="d-flex flex-column align-center justify-center">
              <v-img src="@/assets/logo_inet.png" alt="logo inet" aspect-ratio="1" width="150" height="120" contain transition="scale-transition" :class="loading ? '':'mb-0'"></v-img>
              <div v-if="loading">
                <fulfilling-bouncing-circle-spinner
                  :animation-duration="4000"
                  :size="90"
                  color="#0295CE"
                />
              </div>
            </v-col>
            <v-col cols="12" sm="12" md="10" lg="10" style="margin-top: -30%;">
              <v-form
                v-if="!loading"
                ref="form"
                v-model="valid"
                :lazy-validation="lazy"
                class="form-contain-center"
              >
                <v-row style="padding: 10% 10% !important;">
                  <v-col cols="12" sm="12" md="12" lg="12" class="d-flex align-center justify-center">
                    <v-text-field
                      v-model="email"
                      outlined
                      dense
                      :rules="emailRules"
                      label="ชื่อผู้ใช้"
                      required
                      class="title-login"
                      v-on:keyup.enter="checkInput"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" lg="12" class="d-flex align-center justify-center" style="margin-top: -3%;">
                    <v-text-field
                      v-model="password"
                      :rules="passwordRules"
                      label="รหัสผ่าน"
                      required
                      outlined
                      dense
                      class="title-login"
                      :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="showPassword ? 'text' : 'password'"
                      @click:append="showPassword = !showPassword"
                      v-on:keyup.enter="checkInput"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" lg="12" class="d-flex align-center justify-end" style="margin-top: -8%;">
                    <span style="font-size: 14px; color: grey;">ลืมรหัสผ่าน?</span>
                  </v-col>

                  <v-col cols="12" sm="12" md="12" lg="12">
                    <v-btn
                      block
                      color="primary"
                      large
                      dark
                      class="button-login-title"
                      @click="validate"
                    >
                    เข้าสู่ระบบ
                    </v-btn>
                    <!-- <v-btn
                      block
                      class="button-login-title"
                      :disabled="!valid"
                      @click="validate"
                    >
                      เข้าสู่ระบบ
                    </v-btn> -->
                  </v-col>
                  <!-- <v-col cols="12" sm="12" md="12" lg="12">
                    <br>
                  </v-col> -->
                </v-row>
              </v-form>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
  </div>
    <!-- <v-col cols="12" sm="12" md="12" lg="6"> -->
      <vue-parallax-view v-if="['lg', 'xl'].includes($vuetify.breakpoint.name)" class="my-parallax ml-16" :layers="layers" width="100%" height="100vh" />
    <!-- </v-col> -->
  </div>
  <!-- </v-img> -->
</template>

<script>
import 'vue-parallax-view/dist/vue-parallax-view.css'
import { FulfillingBouncingCircleSpinner } from 'epic-spinners'
import swal from 'sweetalert'
import { loginWithAuth, getUserAuth, getFirstpage } from '@/API/API'

export default {
  name: 'Contentlogin',
  components: {
    FulfillingBouncingCircleSpinner
  },
  data () {
    return {
      layers: [
        {
          name: 'ground',
          horizontalDisplacement: 0.07,
          verticalDisplacement: 0.07,
          // image: require('@/assets/background/greenblue/bg-2.png'),
          class: 'my-parallax-ground'
        },
        {
          name: 'star',
          horizontalDisplacement: 0.15,
          verticalDisplacement: 0.15,
          image: require('@/assets/background/greenblue/bg-3.png'),
          class: 'my-parallax-star'
        },
        {
          name: 'bgmoon',
          horizontalDisplacement: 0.18,
          verticalDisplacement: 0.18,
          // image: require('@/assets/background/greenblue/bg-green-2.png'),
          class: 'my-parallax-bgmoon'
        },
        {
          name: 'moon',
          horizontalDisplacement: 0.15,
          verticalDisplacement: 0.15,
          image: require('@/assets/background/greenblue/bg-green-5.png'),
          class: 'my-parallax-moon'
        }
      ],
      showPassword: false,
      valid: true,
      email: '',
      emailRules: [
        v => !!v || 'กรุณาระบุชื่อผู้ใช้',
        // v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
        v => (v && v.length >= 4) || 'ชื่อผู้ใช้ต้องมีมากกว่า 4 ตัวอักษร'
      ],
      password: '',
      passwordRules: [
        v => !!v || 'กรุณาระบุรหัสผ่าน',
        v => (v && v.length >= 6) || 'รหัสผ่านต้องมีมากกว่า 6 ตัวอักษร'
      ],
      lazy: false,
      loading: false
    }
  },
  methods: {
    checkInput () {
      if (this.email && this.password) {
        this.validate()
      } else if (!this.email) {
        swal('คำเตือน', 'กรุณากรอกอีเมล', 'warning', {
          button: false,
          timer: 3000
        })
      } else if (!this.password) {
        swal('คำเตือน', 'กรุณากรอกรหัสผ่าน', 'warning', {
          button: false,
          timer: 3000
        })
      }
    },
    validate () {
      this.$refs.form.validate()
      // this.$store.commit('storeName', 'nampueng')
      // console.log(this.$store.state.name)
      this.loginUser()
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    async loginUser () {
      this.loading = true
      var obj = {
        username: this.email,
        password: this.password
      }

      try {
        const res = await loginWithAuth(obj)
        if (res.success) {
          this.$store.commit('storeToken', `${res.result.tokenType} ${res.result.accessToken}`)
          this.$store.commit('storeExpiresToken', res.result.expiresIn)
          this.$store.commit('storeUserRole', res.result.status)
          this.$store.commit('setTab', 0)
          localStorage.setItem('addedFriendOneChat', '')
          swal('สำเร็จ', 'เข้าสู่ระบบสำเร็จ', 'success', {
            button: false,
            timer: 2000
          }).then(() => this.getUserByToken())
        } else {
          swal('ผิดพลาด', 'อีเมลหรือรหัสผ่านไม่ถูกต้อง', 'error', {
            button: false,
            timer: 2000
          })
          this.$store.commit('clearToken')
          this.$store.commit('clearExpiresToken')
          // console.log(res)
        }
      } catch (error) {
        // alert(error)
        swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
          button: false,
          timer: 2000
        })
        this.$store.commit('clearToken')
        this.$store.commit('clearExpiresToken')
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async getUserByToken () {
      const obj = {
        companyId: null
      }
      try {
        const res = await getUserAuth(this.$store.state.token, obj)
        if (res.success) {
          this.$store.commit('storeUser', res.result)
          setTimeout(() => {
            this.goHome()
          }, 200)
        }
      } catch (error) {
        console.log(error)
      }
    },
    async goHome () {
      try {
        const firstpage = await getFirstpage(this.$store.state.token)
        // console.log('firstpage', firstpage.result)
        await this.$router.push(localStorage.targetpath ? localStorage.targetpath : this.$store.state.userRole === 'user' ? firstpage.result : 'manageapprovecompany')
      } catch (err) {
        await this.$router.push('orgchart')
        throw new Error(`Problem handling something: ${err}.`)
      }
    }
  }
}
</script>

<style>
.bg-gradient-greenblue {
  max-width: 100%;
  height: 100%;
  background-image: url('../../assets/background/greenblue/bg-green-4.png');
  /* background: linear-gradient(180deg, #07D1BF 0%, #004682 100%); */
  background: linear-gradient(180deg, #171F46 0%, #004682 100%);
}

.my-parallax .my-custom-layer-class {
  position: absolute;
  transform-origin: left bottom;
  will-change: transform;
  transition: 300ms transform linear;
  background-repeat: no-repeat;
  background-size: cover;
}
.my-parallax .centered-axis-xy {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
}
.my-parallax .my-parallax-star {
  height: 30rem !important;
  position: absolute;
  transform-origin: left top;
  will-change: transform;
  transition: 300ms transform linear;
  background-repeat: no-repeat;
  background-size: cover;
}
.my-parallax .my-parallax-bgmoon {
  width: 40rem !important;
  height: 40rem !important;
  left: 5% !important;
  top: 23% !important;
  bottom: 0 !important;
  position: absolute;
  transform-origin: left bottom;
  will-change: transform;
  transition: 300ms transform linear;
  background-repeat: no-repeat;
  background-size: contain;
}
.my-parallax .my-parallax-moon {
  width: 32rem !important;
  height: 32rem !important;
  left: 7% !important;
  top: 23% !important;
  bottom: 0 !important;
  position: absolute;
  transform-origin: left bottom;
  will-change: transform;
  transition: 300ms transform linear;
  background-repeat: no-repeat;
  background-size: contain;
}
.my-parallax .my-parallax-ground {
  position: absolute;
  transform-origin: left bottom;
  will-change: transform;
  transition: 300ms transform linear;
  background-repeat: no-repeat;
  background-size: cover;
}
.box-technology-login {
  z-index: 900;
  position: absolute;
  width: 100% !important;
  height: 100% !important;
  background-color: transparent;
  /* top: 20%;
  right: 10%; */
  width: fit-content;
  height: fit-content;
  /* padding: 4vw 8vw 0 4vw; */
  border: none;
  /* border-radius: 25px; */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.content-technology-login {
  /* height: 31rem;
  width: 33rem; */
  min-width: 95%;
  min-height: 55%;
  border-radius: 10px;
  background: #fff;
  /* padding: 4vw 8vw; */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.content-technology-logingin {
  /* height: 31rem;
  width: 33rem; */
  min-width: 95%;
  min-height: 55%;
  border-radius: 25px;
  background: #fff;
  /* padding: 0 8vw 4vw 8vw; */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
.content-technology-login-button {
  margin: 1em auto;
  display: block;
  -webkit-appearance: none;
  border: 6px solid rgba(255,255,255,0.45);
  border-radius: 50px;
  height: fit-content !important;
  padding: 0.8em 3em !important;
  background-repeat: no-repeat;
  background-size: 100%;
  background-clip: padding-box;
  position: relative;
  color: #FFF;
  transition: all 0.5s;
}
.content-technology-login-button:before {
  content: "";
  width: 100% !important;
  height:100% !important;
  position: absolute;
  top: 5px;
  left: 5px;
  border-radius: 50px;
  z-index: -1;
  filter: blur(14px);
  background-color: rgba(255,255,255,0.1);
  transition: all 0.3s;
}
.content-technology-login-button:hover::before {
  opacity: 0;
  transform: scale(0.5,0.5);
}
.content-technology-login-button:after {
  content: "";
  width: 100% !important;
  height:100% !important;
  position: absolute;
  top: 5px;
  right: 5px;
  border-radius: 50px;
  z-index: -1;
  filter: blur(14px);
  opacity: 0;
  transition: all 0.3s;
  border: 1px solid rgba(255,255,255,0.5);
  transform: scale(1.2,1.2);
}
.content-technology-login-button:hover::after {
  opacity: 1;
  transform: scale(1,1);
}
.content-technology-login-button:hover {
  cursor: pointer;
}
.content-technology-login-button2 {
  background-image: linear-gradient(90deg, #0370B7, #60F4A0);
}
.content-technology-login-button2:before {
  background-image: linear-gradient(90deg, #0370B7, transparent);
}
.content-technology-login-button2:after {
  background-image: linear-gradient(90deg, transparent, #60F4A0);
}
.content-technology-login-button-title {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
  font-size: 18px;
  color: #fff !important;
}
.button-login-title {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 16px;
  color: #fff !important;
  background-color: #3776e9;
}

.title-technology-login {
  font-family: 'Sarabun', sans-serif;
  font-weight: 500px;
  font-size: 20px;
}

.slide-in-bottom {
  -webkit-animation: slide-in-bottom 0.6s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
  animation: slide-in-bottom 0.6s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
}

.form-contain-center {
  width: '100%';
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

@-webkit-keyframes slide-in-bottom {
  0% {
    -webkit-transform: translateY(1000px);
            transform: translateY(1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
    opacity: 1;
  }
}
@keyframes slide-in-bottom {
  0% {
    -webkit-transform: translateY(1000px);
            transform: translateY(1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
    opacity: 1;
  }
}
</style>
